module.exports = __webpack_public_path__ + "static/media/icon.7b1c03be.png";